import { Components, Theme } from '@mui/material';
import { Focused, Disabled } from '../color';
import { CornerSmall } from '../corners';
import getTransition from '../utilities/getTransition';
import { checkboxClasses, TICK_SIZES } from './constants';
import { Spacing2 } from '../spacing';

export const MuiCheckbox: Components<Theme>['MuiCheckbox'] = {
  defaultProps: {
    color: 'secondary',
    disableFocusRipple: true,
    focusRipple: false,
    disableRipple: true,
    centerRipple: false,
    disableTouchRipple: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      borderWidth: 0,
      color: theme.palette.secondary.main,
      boxSizing: 'border-box',
      position: 'relative',
      ':hover': {
        background: theme.palette.action.hover,
      },
      [`.${checkboxClasses.container}`]: {
        minWidth: TICK_SIZES.medium.containerSize,
        height: TICK_SIZES.medium.containerSize,
        borderColor: theme.palette.secondary.main,
        backgroundColor: theme.palette.background.paper,
        boxSizing: 'border-box',
        borderWidth: 1,
        borderStyle: 'solid',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        outlineColor: 'transparent',
        outlineOffset: 0,
        outlineWidth: 2,
        outlineStyle: 'solid',
        ...CornerSmall,
        ...getTransition(['background-color', 'outline-color', 'outline-offset']),
      },
      [`input:focus-visible + .${checkboxClasses.container}`]: {
        outlineColor: Focused.main,
        outlineOffset: 6,
      },
      [`.${checkboxClasses.tick}`]: {
        stroke: theme.palette.secondary.contrastText,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 2,
        fill: 'none',
      },
      [`&.${checkboxClasses.medium}`]: {
        marginInlineEnd: Spacing2,
        width: 32,
        height: 32,
      },
      [`&.${checkboxClasses.small}`]: {
        padding: 5,
        marginInlineEnd: Spacing2,
        [`.${checkboxClasses.container}`]: {
          minWidth: TICK_SIZES.small.containerSize,
          height: TICK_SIZES.small.containerSize,
        },
        [`input:focus-visible + .${checkboxClasses.container}`]: {
          outlineOffset: 3,
        },
      },
      [`&.${checkboxClasses.checked}`]: {
        [`&.${checkboxClasses.small}`]: {
          [`.${checkboxClasses.container}`]: {
            width: TICK_SIZES.small.containerSize,
            height: TICK_SIZES.small.containerSize,
          },
        },
        [`.${checkboxClasses.container}`]: {
          backgroundColor: theme.palette.secondary.main,
        },
      },
      [`&.${checkboxClasses.disabled}`]: {
        [`.${checkboxClasses.container}`]: {
          backgroundColor: Disabled.default.main,
          borderColor: Disabled.default.text,
        },
        [`.${checkboxClasses.tick}`]: {
          stroke: Disabled.default.text,
        },
      },
    }),
    indeterminate: ({ theme }) => ({
      [`.${checkboxClasses.container}`]: {
        backgroundColor: theme.palette.secondary.main,
      },
    }),
  },
};
